import { createSlice } from "@reduxjs/toolkit";

export const MobileSlice = createSlice({
  name: "mobile",
  initialState: {
    isCheckedMobile: false,
    isMobileInValid: null,
    mobile: "",
  },
  reducers: {
    changeMobile: (state, action) => {
      state.mobile = action.payload;
    },
    changeIsCheckedMobile: (state, action) => {
      state.isCheckedMobile = action.payload;
    },
    changeIsMobileInvalid: (state, action) => {
      state.isMobileInValid = action.payload;
    },
  },
});

export const { changeMobile, changeIsCheckedMobile, changeIsMobileInvalid } =
  MobileSlice.actions;
export default MobileSlice.reducer;
